

<div class="row p-2 mat-body-1" style="display: flex;justify-content: space-between;">
  <div *ngIf="showName" class="col-md-7 mat-body-1 displayFlex">
      <span [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
  </div>
</div>

<div *ngIf="errorMessage != null && errorMessage.length > 0" class="row">
  <div  class="error-msg ml-4">{{errorMessage}}</div>
</div>

<div class="row mat-body-1">
<table  cellspacing="0" aria-describedby="Matrix Question table">
  <tr class="stickyRow col-md-12 justify-content-center">
    <th class="col text-center lighterbg"></th>
    <th class="col text-center header lightBlue" *ngFor="let opt of question.options">
      {{ (opt.value.length>20)? (opt.value | slice:0:20)+'..':(opt.value) }}
    </th>
  </tr>
  
 
    <tr *ngFor="let subQuestion of question.subQuestions; let z = index" class="col-md-12" >    
      <td class="col text-center header">      
        <span class="required-star" *ngIf="subQuestion.isQuestionRequired==='Y'">*</span>
        <span>{{subQuestion.questionText}}</span>
      </td>    
      <td class="col text-center" *ngFor="let opt of subQuestion.options;let k = index;">     
        <div *ngIf="subQuestion.inputType == 'rdo' || subQuestion.inputType == 'radiobuttons'">         
          <mat-radio-group class="example-radio-group" [(ngModel)]="subQuestion.responseText">
            <mat-radio-button [value]="opt.value" [disabled]="IsReadOnly" (change)="onSelectRadio($event,subQuestion,z,k)">          
            </mat-radio-button>
          </mat-radio-group>   
        </div>
        <div *ngIf="subQuestion.inputType == 'mul'">
          <input type="text" value="{{opt.value}}" [disabled]="IsReadOnly"
          [style.background-color]="opt.selected && subQuestion.responseText!=null ? 'var(--main-color)': ''"
          [style.color] ="opt.selected && subQuestion.responseText!=null ? 'white': ''"  
          class="blue-border p-1 my-1 cursor m-1 txt-style"             
          (click)="onSelectMultiChoice($event,subQuestion,z,k)" [ariaLabel]="subQuestion.questionText">
        </div>
        <div *ngIf="subQuestion.inputType == 'chk'">
          <mat-checkbox [checked]="opt.selected" [disabled]="IsReadOnly" (change)="onSelectChekbox($event,subQuestion,z,k)"></mat-checkbox>
        </div>               
      </td>
    </tr>
 
 

</table>
</div>


